import api from '../config/api';
import { saveDownload } from '../utils/saveDownload';

// Order API Service
const orderAPI = {
  // Place a new order
  placeOrder: async (orderData) => {
    try {
      const res = await api.post('/orders/place', orderData);
      return res.data;
    } catch (error) {
      console.error('Error placing order:', error);
      throw error;
    }
  },

  // Put a past order back in the cart at current prices (409 = cart not empty, retry with replaceCart).
  reorder: async (orderId, { replaceCart = false } = {}) => {
    const res = await api.post(`/orders/${orderId}/reorder`, { replaceCart });
    return res.data;
  },

  // Get user's orders
  getMyOrders: async () => {
    try {
      const res = await api.get('/orders/my-orders');
      return res.data;
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  },

  // Get order details
  getOrderDetails: async (orderId) => {
    try {
      const res = await api.get(`/orders/${orderId}/details`);
      return res.data;
    } catch (error) {
      console.error('Error fetching order details:', error);
      throw error;
    }
  },

  // Track order
  trackOrder: async (orderId) => {
    try {
      const res = await api.get(`/orders/${orderId}/track`);
      return res.data;
    } catch (error) {
      console.error('Error tracking order:', error);
      throw error;
    }
  },

  // Cancel order
  cancelOrder: async (orderId) => {
    try {
      const res = await api.post(`/orders/${orderId}/cancel`);
      return res.data;
    } catch (error) {
      console.error('Error cancelling order:', error);
      throw error;
    }
  },

  // Rate rider
  rateRider: async (orderId, rating) => {
    try {
      const res = await api.post(`/orders/${orderId}/rate-rider`, {
        rating
      });
      return res.data;
    } catch (error) {
      console.error('Error rating rider:', error);
      throw error;
    }
  },

  // Numbered tax invoice (PDF) of a delivered order
  downloadInvoice: async (orderId) => {
    saveDownload(await api.get(`/orders/${orderId}/invoice`, { responseType: 'blob' }), `invoice-${orderId}.pdf`);
  },
};

export default orderAPI;
